import { LEAD_SOURCE_LABELS, LeadSourceType } from '@sr/dto';

export const formatLeadSourceType = (sourceType?: string) => {
  if (!sourceType) return '-';
  return LEAD_SOURCE_LABELS[sourceType as LeadSourceType] || sourceType;
};
